export default [
    {
        path: '/evaluaciones/agv-campo',
        name: 'evaluacionesbbss',
        component: () => import('@/views/bbss/evaluaciones.vue'),
        meta: {
            pageTitle: 'Agrovision Campo',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Agrovision Campo',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },
    {
        path: '/evaluaciones/agv-packing',
        name: 'agvpacking',
        component: () => import('@/views/bbss/packing.vue'),
        meta: {
            pageTitle: 'Agrovision Packing',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Agrovision Packing',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },
    // ------------------------i
    {
        path: '/bbss/mantenedores/categorias/agv',
        name: 'categoriasagv',
        component: () => import('@/views/bbss/categoria_agv.vue'),
        meta: {
            pageTitle: 'Categorías AGV',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                    active: true,
                },
                {
                    text: 'Mantenedores',
                    active: true,
                },
                {
                    text: 'Categorías',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },

    {
        path: '/bbss/mantenedores/categorias/arv',
        name: 'categoriasarv',
        component: () => import('@/views/bbss/categoria_arv.vue'),
        meta: {
            pageTitle: 'Categorías ARV',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                    active: true,
                },
                {
                    text: 'Mantenedores',
                    active: true,
                },
                {
                    text: 'Categorías',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },

    {
        path: '/bbss/mantenedores/categorias/packing',
        name: 'categoriaspacking',
        component: () => import('@/views/bbss/categoria_packing.vue'),
        meta: {
            pageTitle: 'Categorías Packing',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                    active: true,
                },
                {
                    text: 'Mantenedores',
                    active: true,
                },
                {
                    text: 'Categorías',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },

    {
        path: '/bbss/mantenedores/categorias/campamento',
        name: 'categoriascampamento',
        component: () => import('@/views/bbss/categoria_campamento.vue'),
        meta: {
            pageTitle: 'Categorías Campamento',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                    active: true,
                },
                {
                    text: 'Mantenedores',
                    active: true,
                },
                {
                    text: 'Categorías',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },

    // ------------------------f


    {
        path: '/evaluaciones/arena-verde',
        name: 'arenaverde',
        component: () => import('@/views/bbss/arv.vue'),
        meta: {
            pageTitle: 'Arena Verde',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Arena Verde',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },
    {
        path: '/evaluaciones/campamento',
        name: 'campamento',
        component: () => import('@/views/bbss/campamento.vue'),
        meta: {
            pageTitle: 'Campamento',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Campamento',
                    active: true,
                },
            ],
            resource: 'Evaluaciones BBSS',
            action: 'menu',
        },
    },
    {
        path: '/bbss/mantenedores/categorias/',
        name: 'bbsscategorias',
        component: () => import('@/views/bbss/categorias.vue'),
        meta: {
            pageTitle: 'Categorías',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                    active: true,
                },
                {
                    text: 'Mantenedores',
                    active: true,
                },
                {
                    text: 'Categorías',
                    active: true,
                },
            ],
            resource: 'BBSS Categorias',
            action: 'menu',
        },
    },
    {
        path: '/evaluaciones/eventos',
        name: 'eventosbbss',
        component: () => import('@/views/bbss/entregas.vue'),
        meta: {
            pageTitle: 'Eventos',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Eventos',
                    active: true,
                },
            ],
            resource: 'Eventos BBSS',
            action: 'menu',
        },
    },
    {
        path: '/bbss/absentismos',
        name: 'absentismosbbss',
        component: () => import('@/views/bbss/absentismos.vue'),
        meta: {
            pageTitle: 'Absentismos',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Absentismos',
                    active: true,
                },
            ],
            resource: 'SA Absentismos',
            action: 'menu',
        },
    },
    {
        path: '/bbss/asignaciones',
        name: 'asignacionesbbss',
        component: () => import('@/views/bbss/asignaciones.vue'),
        meta: {
            pageTitle: 'Asignaciones Familiares',
            breadcrumb: [
                {
                    text: 'Bienestar Social',
                },
                {
                    text: 'Asignaciones Familiares',
                    active: true,
                },
            ],
            resource: 'SA Asignaciones Familiares',
            action: 'menu',
        },
    },
]
